import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { excUserInfo, initialState } from 'app/core/models/slice/frx/frx'

const slice = createSlice({
    name: 'excUserInfo',
    initialState,
    reducers: {
        clearExcUserInfo: (state) => {
            state = { ...initialState }
        },

        setExcUserInfo: (state, action: PayloadAction<excUserInfo>) => {
            Object.keys(action.payload).map((key) => {
                state[key] = action.payload[key]
            })
        },
    },
})

export const { clearExcUserInfo, setExcUserInfo } = slice.actions

export default slice.reducer
